import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=b7eae83c"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7eae83c')) {
      api.createRecord('b7eae83c', component.options)
    } else {
      api.reload('b7eae83c', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=b7eae83c", function () {
      api.rerender('b7eae83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/userProfile/Editor.vue"
export default component.exports